<template>
    <div class="buyflow-panel">
        <div v-if="phoneInterest"
             class="grid
                    grid-cols-12
                    gap-4">
            <div class="col-span-12 desktop:col-span-9
                        font-bold
                        text-xl desktop:text-2xl
                        leading-tight desktop:leading-snug">
                {{ phoneInterest.title }}
            </div>
            <div class="col-span-12">
                <img alt="" class="object-cover w-full h-48 rounded-md" src="/assets/images/buyflow/billboard-phone.jpeg" />
            </div>
            <div class="col-span-12 desktop:col-span-9
                        text-sm desktop:text-md
                        leading-snug
                        mb-6 desktop:mb-0">
                Unlimited Phone Service is not available in your area at this time. If you would like to be notified when phone service is available,
                please click “Notify Me”. Your account will not be charged for phone service until you enroll with a representative.
            </div>
            <div class="col-span-12 desktop:col-span-3
                        ml-auto
                        w-auto">
                <button
                    @click="$emit('select', { serviceAndOptions: { decision: unlimitedPhone.decision, selection: [phoneInterest]}})"
                    :disabled="isSelected(phoneInterest)"
                    class="buyflow-button flex items-center"
                >
                    <template v-if="isSelected(phoneInterest)">
                        <IconCheck class="mr-1" />
                        Will be Notified
                    </template>
                    <template v-else>
                        <IconPlus class="mr-1" />
                        Notify Me
                    </template>
                </button>
            </div>
        </div>


        <div v-else-if="unlimitedPhone"
             class="grid
                    grid-cols-12
                    gap-4">
            <div class="col-span-12 desktop:col-span-9
                        font-bold
                        text-xl desktop:text-2xl
                        leading-tight desktop:leading-snug">
                {{ unlimitedPhone.title }}
            </div>
            <div class="hidden desktop:block
                        col-span-3
                        justify-self-end">
                <PricePerMonth :price="getServicePrice(unlimitedPhone)" />
            </div>
            <div class="col-span-12">
                <img alt="" class="object-cover w-full h-48 rounded-md" src="/assets/images/buyflow/billboard-phone.jpeg" />
            </div>
            <div class="col-span-12 desktop:col-span-9
                        text-sm desktop:text-md
                        leading-snug
                        mb-6 desktop:mb-0">
                Stay in touch with friends and family anywhere in the world without worry about what it will cost you.
            </div>
            <div class="col-span-12 desktop:col-span-3
                        justify-self-end
                        self-end
                        flex desktop:block
                        flex-row
                        justify-between
                        w-full desktop:w-auto">
                <PricePerMonth :price="getServicePrice(unlimitedPhone)"
                               class="desktop:hidden" />
                    <AppModal v-if="isOhio && hasSelectedSelfInstall === true && meta.customerState !== 'moving'"
                              :disable-modal="isSelected(unlimitedPhone)"
                              modal-type="info">
                        <template #trigger>
                            <button
                                type="button"
                                class="buyflow-button flex items-center"
                                :disabled="isSelected(unlimitedPhone)"
                                >
                            <template v-if="isSelected(unlimitedPhone)">
                                <IconCheck class="mr-1" />
                                Added
                            </template>
                            <template v-else>
                                <IconPlus class="mr-1" />
                                Add Home Phone
                            </template>
                        </button>
                        </template>
                        <template #contents>
                            <div class="text-base
                                        font-bold
                                        mb-2">
                                By adding Home Phone to your order you will be changing your install option to Professional Install
                            </div>
                            <div class="text-sm
                                        mt-3
                                        font-normal">
                                The benefits of Professional Install:
                                <div class="mt-1 flex">
                                    <IconCheck class="mr-1" /> A Professional Tech will arrive at your home to install and set up your service.
                                </div>
                                <div class="mt-1 flex">
                                    <IconCheck class="mr-1" /> You can choose your date and time for install at checkout.
                                </div>
                            </div>
                        </template>
                        <template #confirm>
                            <button type="button"
                                    class="buyflow-button mt-5"
                                    @click="$emit('set-install-type', professional);$emit('select', { serviceAndOptions: { decision: unlimitedPhone.decision, selection: [unlimitedPhone, port]}, declined: false})">
                                Confirm Selection
                            </button>
                        </template>
                    </AppModal>
                    <button v-else type="button"
                        class="buyflow-button flex items-center"
                        :disabled="isSelected(unlimitedPhone)"
                        @click="$emit('select', { serviceAndOptions: { decision: unlimitedPhone.decision, selection: [unlimitedPhone, port]}, declined: false})">
                    <template v-if="isSelected(unlimitedPhone)">
                        <IconCheck class="mr-1" />
                        Added
                    </template>
                    <template v-else>
                        <IconPlus class="mr-1" />
                        Add Home Phone
                    </template>
                </button>

            </div>
        </div>

        <div v-if="isSelected(unlimitedPhone)"
             class="grid
                    grid-cols-2
                    gap-4
                    mt-4
                    border-t
                    pt-4">
            <div class="flex
                        flex-row
                        justify-center
                        items-center
                        cursor-pointer"
                 :class="isSelected(port,2) ? null : 'hover:text-salmon'">
                <input type="radio"
                       name="port-options"
                       class="w-6
                              h-6
                              mr-4"
                       :checked="isSelected(port,2)"
                       @click="selectOption(port)" />
                <div @click="selectOption(port)"
                     class="leading-snug">
                    <div class="font-bold
                                text-base desktop:text-lg">
                        {{ port.name }}
                    </div>
                    <div class="text-sm">
                        Keep my existing phone number
                    </div>
                </div>
            </div>
            <div class="flex
                        flex-row
                        justify-center
                        items-center
                        cursor-pointer
                        border-l
                        pl-4"
                 :class="isSelected(host,2) ? null : 'hover:text-salmon'">
                <input type="radio"
                       name="port-options"
                       class="w-6
                              h-6
                              mr-4"
                       :checked="isSelected(host,2)"
                       @click="selectOption(host)" />
                <div @click="selectOption(host)"
                     class="leading-snug">
                    <div class="font-bold
                                text-base desktop:text-lg">
                        {{ host.name }}
                    </div>
                    <div class="text-sm">
                        Receive a new phone number
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState, mapGetters } from 'vuex'
    import IconPlus from "@/atoms/icons/IconPlus"
    import IconCheck from "@/atoms/icons/IconCheck"
    import PricePerMonth from "@/atoms/PricePerMonth"
    import AppModal from "~/Buyflow/components/AppModal"

    export default {
        name: 'VoiceServices',
        components: {
            PricePerMonth,
            AppModal,
            IconCheck,
            IconPlus,
        },
        props: {
            services: {
                type: Object,
                required: true,
            },
            portOptions: {
                type: Object,
                required: true,
            },
            credits: {
                type: Array,
                default: () => ([]),
            },
            getServicePrice: {
                type: Function,
                default: () => 0,
            },
            isSelected: {
                type: Function,
                required: true,
            },
            hasSelectedSelfInstall: {
                type: Boolean,
                default: false,
            },
            voiceData: {
                type: Object,
                required: true,
            },
            professional: {
                type: Object,
                required: true,
            },
        },
        computed: {
            ...mapState([
                'meta',
            ]),
            ...mapGetters('Buyflow', [
                'isOhio',
            ]),
            port() {
                return this.portOptions.port
            },
            host() {
                return this.portOptions.host
            },
            phoneInterest() {
                return this.services.phoneInterest
            },
            unlimitedPhone() {
                return this.services.unlimitedPhone
            },
        },
        methods: {
            selectOption(option) {
                if (!this.isSelected(option, 2)) {
                    this.$emit('select', { serviceAndOptions: { decision: this.unlimitedPhone.decision, selection: [this.unlimitedPhone, option]}})
                }
            },
        }
    }
</script>
